<template>
  <f7-page data-tour-id="issued-invoices-page-root">
    <!-- LOADER BONITO NO BLOQUEANTE -->
    <div v-if="isLoading" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader />
        <div class="preloader-text">{{ $t('loading') }}</div>
      </div>
    </div>
    <div v-if="loaded">
      <div class="custom-table-container tableContainer">
        <IssuedInvoiceListTable
          ref="issuedInvoiceListTable"
          :store="customStore"
        />
      </div>
    </div>
  </f7-page>
</template>
<script>
import IssuedInvoiceListTable from '@/components/IssuedInvoicesList/IssuedInvoiceListTable.vue';
import { mapState, mapActions } from 'vuex';
import EventBus from '@/services/event-bus';
import {
  ISSUED_INVOICES_GUIDED_TOUR_AUTO_START_DELAY,
  NOTIFY_TIME_LONG,
} from '@/js/constants';
import {
  consumePendingIssuedInvoicesListTourStart,
  startIssuedInvoicesListGuidedTour,
  stopIssuedInvoicesGuidedTour,
} from '@/services/issuedInvoicesGuidedTour';

export default {
  components: { IssuedInvoiceListTable },
  data() {
    return {
      loaded: false,
      customStore: null,
      loading: false,
      guidedTourStartTimeoutId: null,
    };
  },
  computed: {
    ...mapState('contact', ['company', 'addresses']),
    ...mapState('issuedInvoicesModule', [
      'issuedInvoiceList',
      'isLoading',
      'firstLoadDone',
    ]),
  },
  watch: {
    // Muestra/oculta preloader automÃ¡ticamente
    isLoading: {
      immediate: true,
      handler(v) {
        // Solo mostrar loader si NO hay datos todavÃ­a
        // Loader SOLO en la primera carga
        this.loading = v && !this.firstLoadDone;
        if (!v && this.loaded && this.firstLoadDone) {
          this.scheduleIssuedInvoicesGuidedTourStart();
        }
      },
    },
    // Refresca la tabla al aplicar filtros
    issuedInvoiceList: {
      immediate: true,
      handler(list) {
        this.customStore = Array.isArray(list) ? list : [];
        this.loaded = true;
      },
    },
    loaded(value) {
      if (value) {
        this.scheduleIssuedInvoicesGuidedTourStart();
      } else {
        this.clearIssuedInvoicesGuidedTourStartTimeout();
      }
    },
    firstLoadDone(value) {
      if (value && this.loaded && !this.isLoading) {
        this.scheduleIssuedInvoicesGuidedTourStart();
      }
    },
  },
  beforeMount() {
    // Fecha fin hoy
    const to = new Date();
    // Fecha inicio hace 6 meses
    const from = new Date();
    from.setMonth(from.getMonth() - 6);
    this.$store.commit(
      'issuedInvoicesFilter/setInitialFromDate',
      from
    );
    this.$store.commit('issuedInvoicesFilter/setInitialToDate', to);
    this.setCurrentFilter('issuedInvoicesList');
    this.applyCurrentFilters();
    this.setCurrentRoute([
      {
        name: this.$t('myIssuedInvoices'),
        disabled: false,
        page: 'IssuedInvoicesList',
        active: true,
      },
    ]);
  },
  async mounted() {
    try {
      this.customStore = this.issuedInvoiceList;
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(error.message)
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    }
  },
  beforeDestroy() {
    this.clearIssuedInvoicesGuidedTourStartTimeout();
    stopIssuedInvoicesGuidedTour(this);
    EventBus.$off('IssuedInvoicesList');
  },
  methods: {
    clearIssuedInvoicesGuidedTourStartTimeout() {
      if (this.guidedTourStartTimeoutId) {
        clearTimeout(this.guidedTourStartTimeoutId);
        this.guidedTourStartTimeoutId = null;
      }
    },
    scheduleIssuedInvoicesGuidedTourStart({ force = false } = {}) {
      if (!this.loaded || this.isLoading || !this.firstLoadDone) {
        return;
      }

      const shouldContinueFromDashboard =
        force || consumePendingIssuedInvoicesListTourStart();
      if (!shouldContinueFromDashboard) {
        return;
      }

      this.clearIssuedInvoicesGuidedTourStartTimeout();
      this.guidedTourStartTimeoutId = setTimeout(() => {
        this.guidedTourStartTimeoutId = null;
        startIssuedInvoicesListGuidedTour(this, { force: true });
      }, ISSUED_INVOICES_GUIDED_TOUR_AUTO_START_DELAY);
    },
    openTourFiltersPanel() {
      this.$f7.panel.open('right');
    },
    closeTourFiltersPanel() {
      this.$f7.panel.close('right', false);
    },
    hasTourIssuedInvoices() {
      return Array.isArray(this.customStore)
        ? this.customStore.some((item) => item?.CodFactura)
        : false;
    },
    async openTourIssuedInvoiceDetail(options = {}) {
      return (
        (await this.$refs.issuedInvoiceListTable?.openTourIssuedInvoiceDetail?.(
          options
        )) || { opened: false }
      );
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('IssuedInvoices', ['fetchPresupuestos']),
    ...mapActions('filter', [
      'setCurrentFilter',
      'applyCurrentFilters',
    ]),
    ...mapActions('issuedInvoicesModule', ['fetchIssuedInvoiceList']),
  },
};
</script>
